import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1754f615"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "nav-category navbar-collapse collapse mr-auto"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "navbar-toggler-icon"
}, null, -1));

const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  key: 0,
  class: "nav-category collapse",
  id: "homecategory",
  style: {
    "flex-basis": "100%"
  }
};
import WeatherHeader from "../components/common/WeatherHeader.vue";
import { useRoute, useRouter } from "vue-router";
import menu from "./menu";
import { ref, onUnmounted, onMounted, onActivated, onDeactivated, watch, computed } from "vue";
import PageFooter from "../components/common/PageFooter.vue";
import PageHeader from "../components/common/PageHeader.vue";
export default {
  __name: 'Layout',

  setup(__props) {
    // 在setup块中，导入的组件可以直接使用
    const collapsedBtn = ref(null);
    const topCategory = ["blog", "demo"];
    const rounte = useRoute();
    const rounter = useRouter();
    const categories = menu.categories;

    function toCategoryHome(category) {
      category = category.toLowerCase();
      rounter.push(`/${category.toLowerCase()}`);
    }

    const showCollaspedCategory = ref(false);

    const checkCollapsedCategory = function () {
      if (collapsedBtn.value && collapsedBtn.value.offsetParent !== null) {
        showCollaspedCategory.value = true;
      } else {
        showCollaspedCategory.value = false;
      }
    };

    onMounted(() => {
      window.addEventListener('resize', checkCollapsedCategory, true);
      checkCollapsedCategory();
    });
    onUnmounted(() => {
      window.removeEventListener('resize', checkCollapsedCategory);
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");

      const _component_router_view = _resolveComponent("router-view");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(PageHeader, null, {
        topLeft: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_router_link, {
          to: "home",
          class: "m-1 pointer fw-bold",
          role: "button"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString('首页'))]),
          _: 1
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), category => {
          return _openBlock(), _createBlock(_component_router_link, {
            key: category.path,
            to: category.path.toLowerCase(),
            class: "m-1 pointer fw-bold",
            role: "button"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(category.name), 1)]),
            _: 2
          }, 1032, ["to"]);
        }), 128))]), _createVNode(WeatherHeader)]),
        topLeftCollapsed: _withCtx(() => [_createElementVNode("button", {
          class: "navbar-toggler",
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#homecategory",
          "aria-controls": "homecategory",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation",
          onClick: _cache[0] || (_cache[0] = $event => _ctx.topBarExpand = !_ctx.topBarExpand),
          ref_key: "collapsedBtn",
          ref: collapsedBtn
        }, _hoisted_3, 512), showCollaspedCategory.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_router_link, {
          to: "home",
          class: "m-1 pointer fw-bold",
          role: "button"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString('首页'))]),
          _: 1
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), category => {
          return _openBlock(), _createBlock(_component_router_link, {
            key: category.path,
            to: category.path.toLowerCase(),
            class: "m-1 pointer fw-bold",
            role: "button"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(category.name), 1)]),
            _: 2
          }, 1032, ["to"]);
        }), 128))])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component,
          route
        }) => [(_openBlock(), _createBlock(_KeepAlive, null, [route.meta && route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: route.path
        })) : _createCommentVNode("", true)], 1024)), !route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: route.path
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(PageFooter)]);
    };
  }

};